

































































































































import IInboundDeliveryNotesDetail from '@/store/models/IInboundDeliveryNotesDetail';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import moment from 'moment';
@Component({
    components: {
        Snackbar
    }
})
export default class InboundsNoticeOfLossDeliveryNotesDetailSelector extends Vue {
    searchInboundDeliveryNotesDetail : string = "";
    selectedInboundDeliveryNotesDetail : IInboundDeliveryNotesDetail[] = [];
    dialog: boolean = false;
    isValid: boolean = true;
    maxCasesPerPallet : number = 0;
    sortBy: string = 'goodName';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        { text: 'Pallet', value: 'palletName' },
        { text: 'Pallet id', value: 'idPallet' },
        { text: 'Cases per pallet', value: 'casesPerPallet' },
        { text: 'Goods per case', value: 'goodsPerCase' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'Best before date', value: 'bestBeforeDate' },
        { text: 'Actions', value: 'actions' }
    ];

    @Prop({ type: Array, required: true })
    InboundDeliveryNotesDetailList !: IInboundDeliveryNotesDetail[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop()
    value !: IInboundDeliveryNotesDetail[];

    editedIndex : number = -1;
    editedItem : IInboundDeliveryNotesDetail = {
        id: "",
        idInboundDeliveryNote: "",
        idInboundDetail: "",
        idGood: "",
        goodName: "",
        idListPallet: "",
        palletName: "",
        palletsAmount: 0,
        casesPerPallet: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        location: "",
        weight: 0,
        bestBeforeDate: new Date(),
        idPallet: "",
        casesLoss: 0,
        language: ""
    }
    defaultItem : IInboundDeliveryNotesDetail = {
        id: "",
        idInboundDeliveryNote: "",
        idInboundDetail: "",
        idGood: "",
        goodName: "",
        idListPallet: "",
        palletName: "",
        palletsAmount: 0,
        casesPerPallet: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        location: "",
        weight: 0,
        bestBeforeDate: new Date(),
        idPallet: "",
        casesLoss: 0,
        language: ""
    }

    get formTitle() { return this.editedIndex === -1 ? 'New Inbound Detail Delivery Note Detail' : 'Edit Inbound Detail Delivery Note Detail'; }

    @Watch('value')
    updateSelection(newValue : IInboundDeliveryNotesDetail[] | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedInboundDeliveryNotesDetail = [];
        }
    }

    @Watch('selectedInboundDeliveryNotesDetail')
    onChangeselectedInboundDeliveryNotesDetail() {
        if (this.selectedInboundDeliveryNotesDetail.length > 0) {
            this.$emit('input', this.selectedInboundDeliveryNotesDetail);
        } else {
            this.$emit('input', null);
        }
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }
   
    editInboundDeliveryNotesDetail (item: any, dbox = true) {
        if (this.selectedInboundDeliveryNotesDetail.length > 0) {
            this.editedIndex = this.InboundDeliveryNotesDetailList.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.maxCasesPerPallet = this.editedItem.casesPerPallet;
            this.dialog = true;
        }
    }

    saveInboundDeliveryNotesDetail() {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            let index = this.InboundDeliveryNotesDetailList.findIndex(i => i.idPallet === this.editedItem.idPallet);
            Object.assign(this.InboundDeliveryNotesDetailList[index], this.editedItem);
            this.close();
        } else {
            this.showMessageWarning("Please, some fields have not passed the validation to be able to save.");
        }
    }

    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }

    CalculateGoods() {
        if (this.editedItem.casesPerPallet > 0 && this.editedItem.goodsPerCase > 0) {
            this.editedItem.totalGoods = this.editedItem.casesPerPallet * this.editedItem.goodsPerCase;
        }
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }
}
